import React from 'react';
import { 
  HelpCircle, 
  Percent, 
  Calculator, 
  DivideSquare, 
  BookOpen, 
  TrendingUp, 
  Grid 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Percent,
      title: 'Проценты (%)',
      description: 'Стандартный способ выражения доли. 100% = целое, 50% = половина.'
    },
    {
      icon: Calculator,
      title: 'Десятичная дробь',
      description: 'Число от 0 до 1, где 1 = 100%. Удобно в математических расчетах.'
    },
    {
      icon: DivideSquare,
      title: 'Обыкновенная дробь',
      description: 'Представление в виде отношения частей. Например, 1/4 = 25%.'
    },
    {
      icon: BookOpen,
      title: 'Применение в финансах',
      description: 'Проценты используются в инвестициях, кредитах, депозитах для расчета доходности.'
    },
    {
      icon: TrendingUp,
      title: 'Экономические показатели',
      description: 'Инфляция, рентабельность, доля рынка часто выражаются в процентах.'
    },
    {
      icon: Grid,
      title: 'Статистика и аналитика',
      description: 'Проценты помогают сравнивать и анализировать различные показатели.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-green-500" />
        Советы по работе с процентами
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Calculator className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Важно знать
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              Понимание различных форм представления процентов поможет вам 
              более точно интерпретировать числовые данные в финансах и статистике.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;